import { render, staticRenderFns } from "./PiggyConnectModal.vue?vue&type=template&id=31c3fbb4"
import script from "./PiggyConnectModal.vue?vue&type=script&lang=js"
export * from "./PiggyConnectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports